import { ReportGroup } from "Models/reports.groups";
import { ReportName, ReportSubGroup, ResourceName } from "Util/enums";

const ORDER_REPORT_NAME = ReportName.ORDER_REPORT.toLowerCase();

export const applyOrderReportFlagToGroups = (
  groups: ReportGroup[] | undefined,
  managementOrderReportEnabled: boolean
): ReportGroup[] => {
  if (!groups?.length) return [];

  return groups
    .map((reportGroup) => {
      const reports = reportGroup?.reports || [];
      const filteredReports = reports.filter(
        (report) => report?.name?.toLowerCase() !== ORDER_REPORT_NAME
      );
      const managementReportGroup =
        reportGroup?.group?.toLowerCase() === ResourceName.MANAGEMENT?.toLowerCase()
          ? { ...reportGroup, subGroup: reportGroup.subGroup || ReportSubGroup.Management }
          : reportGroup;

      if (!managementOrderReportEnabled) {
        return { ...managementReportGroup, reports: filteredReports };
      }

      if (reportGroup?.group?.toLowerCase() !== ResourceName.MANAGEMENT?.toLowerCase()) {
        return { ...reportGroup, reports: filteredReports };
      }

      const hasOrderReport = reports.some(
        (report) => report?.name?.toLowerCase() === ORDER_REPORT_NAME
      );

      if (hasOrderReport) {
        return managementReportGroup;
      }

      return {
        ...managementReportGroup,
        reports: [
          ...filteredReports,
          {
            id: -1508000 - (reportGroup.id || 0),
            valid: true,
            name: ReportName.ORDER_REPORT,
            description: ReportName.ORDER_REPORT,
            status: "Active",
            reportGroupId: reportGroup.id,
          },
        ],
      };
    })
    .filter((reportGroup) => (reportGroup?.reports || []).length > 0);
};
